import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useLocation, useNavigate, useParams } from 'react-router-dom';
import { setPromptInfo } from '../common/navigation/containers/navigation-actions';

export const withRouter = (Component) => {
  const Wrapper = (props) => {
    const location = useLocation();
    const params = useParams();
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const { isNavigationBlocked } = useSelector(state => state.navigation);

    const match = {
      params,
    };

    const handlePush = (url, state) => {
      if (!isNavigationBlocked) {
        navigate(url, { state });
      } else if (state?.cancelBlock) {
        dispatch(setPromptInfo(null));
        navigate(url, { state });
      } else {
        dispatch(setPromptInfo({
          url,
          state,
        }));
      }
    };

    const handleReplace = (url, state) => {
      if (!isNavigationBlocked) {
        navigate(url, {
          replace: true,
          state,
        });
      } else if (state?.cancelBlock) {
        dispatch(setPromptInfo(null));
        navigate(url, {
          replace: true,
          state,
        });
      } else {
        dispatch(setPromptInfo({
          url,
          state,
          replace: true,
        }));
      }
    };

    const history = {
      canGoBack: location?.key !== 'default',
      back: () => navigate(-1),
      location,
      push: handlePush,
      replace: handleReplace,
    };

    return (
      <Component
        history={history}
        location={location}
        match={match}
        navigate={navigate}
        {...props}
      />
    );
  };

  return Wrapper;
};

export default withRouter;
